module.exports = __webpack_public_path__ + "static/media/engagement-puzzle.be95f78d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/engagement-puzzle.svg
// module id = 392
// module chunks = 0